import ProductsCard from "./components/ProductsCard";
import Products from "./components/Products";

function App() {
  return (
    <div className="bg-gray-50 h-auto">
      <div className="grid place-items-center">
        <h1 className="text-gray-900 font-bold text-3xl p-10 underline decoration-purple-500 decoration-4 underline-offset-8 mb-4">
          Shopping Cart BY MIRAZ🤞
        </h1>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <Products />
        <ProductsCard />
      </div>
    </div>
  );
}

export default App;
